import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import { InstallStatus, LoginStatus, ThirdPartyAuthData, UserInfo, OauthData } from '../../_interface/user-int';
import { LocationInfo } from '../../_interface/uplocation-int';
import { ImagePickerInfo, ImageInfo, TransPathInfo, OpenCameraInfo } from '../../_interface/upimage-int';
import { AttrData } from '../../_interface/audiorecorder-int';
import { AppInformation, PhoneInfo } from '../../_interface/appinfo-int';
import { NetworkInfo, NetworkStatus } from '../../_interface/upnetwork-int';
import { FamilyInfo, FamilyOwnerDetail, MemberInfo, MemberDetail, FamilyDetail, FamilyLocationDetail, RoomInfo, DeviceInfo, OwnerDetail, PermissionDetail, AuthDetail, FloorInfo } from '../../_interface/family-int';
import { Attribute, BaseInfo, LeDeviceAttribute, BusinessAttr, CmdPara, ValueRange } from '../../_interface/logicengine-int';
import { Alarm, DeviceModel, FOTAInfo, FOTAStatus, UpDeviceBaseInfo, DeviceModelMixLogicAttrs, NetWorkQualityModel, SimplifyDataModel, PlaybackItem, BindProgress } from '../../_interface/updevice-int';
import { InitResult } from '../../_interface/speechrecognition-int';
import { ClipboardValue } from '../../_interface/upsystem-int';

var ContainerPlugin = function () {
    function ContainerPlugin() {
        var _this = this;

        _classCallCheck(this, ContainerPlugin);

        this.convertUpdeviceBaseInfoFrom = function (ret) {
            var infoList = ret.retData ? ret.retData : [];
            var list = [];
            infoList.map(function (info) {
                var infoObj = { baseInfo: _this.createUpdeviceBaseInfoFrom(info.baseInfo) };
                list.push(infoObj);
            });
            return list;
        };
        this.convertDeviceListFrom = function (ret) {
            var deviceList = ret.retData ? ret.retData : [];
            var list = [];
            deviceList.map(function (device) {
                list.push(_this.createDeviceModelFrom(device));
            });
            return list;
        };
        this.convertDeviceMixLogicAttrsListFrom = function (ret) {
            var deviceList = ret.retData ? ret.retData : [];
            var list = [];
            deviceList.map(function (device) {
                list.push(_this.createDeviceInfoModelFrom(device));
            });
            return list;
        };
        this.convertUpDeviceModelFrom = function (ret) {
            var deviceInfo = ret.retData ? ret.retData : {};
            return _this.createDeviceModelFrom(deviceInfo);
        };
        this.convertUpDeviceNetWorkQualityModelFrom = function (ret) {
            var qualityInfo = ret.retData ? ret.retData : {};
            var qualityModel = new NetWorkQualityModel();
            qualityModel.deviceConnectStatus = qualityInfo ? qualityInfo.deviceConnectStatus : '';
            qualityModel.machineId = qualityInfo ? qualityInfo.machineId : '';
            qualityModel.isOnLine = qualityInfo ? qualityInfo.isOnLine : false;
            qualityModel.statusLastChangeTime = qualityInfo ? qualityInfo.statusLastChangeTime : '';
            qualityModel.netType = qualityInfo ? qualityInfo.netType : '';
            qualityModel.ssid = qualityInfo ? qualityInfo.ssid : '';
            qualityModel.rssi = qualityInfo ? qualityInfo.rssi + '' : '';
            qualityModel.prssi = qualityInfo ? qualityInfo.prssi + '' : '';
            qualityModel.signalLevel = qualityInfo ? qualityInfo.signalLevel + '' : '';
            qualityModel.ilostRatio = qualityInfo ? qualityInfo.ilostRatio + '' : '';
            qualityModel.its = qualityInfo ? qualityInfo.its + '' : '';
            qualityModel.lanIP = qualityInfo ? qualityInfo.lanIP : '';
            qualityModel.moduleVersion = qualityInfo ? qualityInfo.moduleVersion : '';
            return qualityModel;
        };
        this.convertSimplifyListFrom = function (ret) {
            var deviceList = ret.retData ? ret.retData : [];
            var list = [];
            deviceList.map(function (device) {
                list.push(_this.createSimplifyModelFrom(device));
            });
            return list;
        };
    }

    _createClass(ContainerPlugin, [{
        key: 'convertClipboardValueFrom',
        value: function convertClipboardValueFrom(ret) {
            var _a, _b;
            var info = new ClipboardValue();
            info.value = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
            return info;
        }
    }, {
        key: 'convertInitSpeechResult',
        value: function convertInitSpeechResult(ret) {
            var _a, _b, _c, _d;
            var initResult = new InitResult();
            initResult.rawData = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.rawData) !== null && _b !== void 0 ? _b : '';
            initResult.status = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.status) !== null && _d !== void 0 ? _d : false;
            return initResult;
        }
    }, {
        key: 'convertThirdAuthDataFrom',
        value: function convertThirdAuthDataFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            var thirdAuthData = new ThirdPartyAuthData();
            thirdAuthData.accessToken = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.accessToken) !== null && _b !== void 0 ? _b : '';
            thirdAuthData.openId = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.openId) !== null && _d !== void 0 ? _d : '';
            thirdAuthData.realOpenId = (_f = (_e = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _e === void 0 ? void 0 : _e.realOpenId) !== null && _f !== void 0 ? _f : '';
            thirdAuthData.socialAppId = (_h = (_g = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _g === void 0 ? void 0 : _g.socialAppId) !== null && _h !== void 0 ? _h : '';
            thirdAuthData.socialAppSecret = (_k = (_j = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _j === void 0 ? void 0 : _j.socialAppSecret) !== null && _k !== void 0 ? _k : '';
            thirdAuthData.authorizationCode = (_m = (_l = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _l === void 0 ? void 0 : _l.authorizationCode) !== null && _m !== void 0 ? _m : '';
            thirdAuthData.nickName = (_p = (_o = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _o === void 0 ? void 0 : _o.nickName) !== null && _p !== void 0 ? _p : '';
            thirdAuthData.iconUrl = (_r = (_q = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _q === void 0 ? void 0 : _q.iconUrl) !== null && _r !== void 0 ? _r : '';
            return thirdAuthData;
        }
    }, {
        key: 'convertLEBaseInfoFrom',
        value: function convertLEBaseInfoFrom(ret) {
            var baseInfo = new BaseInfo(ret);
            return baseInfo;
        }
    }, {
        key: 'convertLECautionListFrom',
        value: function convertLECautionListFrom(ret) {
            var _a, _b, _c, _d, _e;
            var array = new Array();
            var resultData = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : array;
            for (var i = 0; i < resultData.length; i++) {
                var item = resultData[i];
                var caution = {
                    name: (_b = item === null || item === void 0 ? void 0 : item.name) !== null && _b !== void 0 ? _b : '',
                    code: (_c = item === null || item === void 0 ? void 0 : item.code) !== null && _c !== void 0 ? _c : '',
                    desc: (_d = item === null || item === void 0 ? void 0 : item.desc) !== null && _d !== void 0 ? _d : '',
                    clear: (_e = item === null || item === void 0 ? void 0 : item.clear) !== null && _e !== void 0 ? _e : false
                };
                array.push(caution);
            }
            return array;
        }
    }, {
        key: 'convertLEAttributeFrom',
        value: function convertLEAttributeFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var resultData = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : new Attribute();
            var valueRange = new ValueRange();
            valueRange.dataDate = undefined;
            valueRange.type = 'NONE';
            var attr = new Attribute();
            attr = {
                code: (_b = resultData === null || resultData === void 0 ? void 0 : resultData.code) !== null && _b !== void 0 ? _b : [],
                defaultValue: (_c = resultData === null || resultData === void 0 ? void 0 : resultData.defaultValue) !== null && _c !== void 0 ? _c : '',
                desc: (_d = resultData === null || resultData === void 0 ? void 0 : resultData.desc) !== null && _d !== void 0 ? _d : '',
                invisible: (_e = resultData.invisible) !== null && _e !== void 0 ? _e : false,
                name: (_f = resultData === null || resultData === void 0 ? void 0 : resultData.name) !== null && _f !== void 0 ? _f : '',
                operationType: (_g = resultData === null || resultData === void 0 ? void 0 : resultData.operationType) !== null && _g !== void 0 ? _g : 'I',
                readable: (_h = resultData === null || resultData === void 0 ? void 0 : resultData.readable) !== null && _h !== void 0 ? _h : false,
                value: (_j = resultData === null || resultData === void 0 ? void 0 : resultData.value) !== null && _j !== void 0 ? _j : '',
                valueRange: (_k = resultData === null || resultData === void 0 ? void 0 : resultData.valueRange) !== null && _k !== void 0 ? _k : valueRange,
                writable: (_l = resultData === null || resultData === void 0 ? void 0 : resultData.writable) !== null && _l !== void 0 ? _l : false
            };
            return attr;
        }
    }, {
        key: 'convertLEAttributeListFrom',
        value: function convertLEAttributeListFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var array = new Array();
            var resultData = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : array;
            var valueRange = new ValueRange();
            valueRange.dataDate = undefined;
            valueRange.type = 'NONE';
            for (var i = 0; i < resultData.length; i++) {
                var item = resultData[i];
                var attr = new Attribute();
                attr = {
                    code: (_b = item === null || item === void 0 ? void 0 : item.code) !== null && _b !== void 0 ? _b : [],
                    defaultValue: (_c = item === null || item === void 0 ? void 0 : item.defaultValue) !== null && _c !== void 0 ? _c : '',
                    desc: (_d = item === null || item === void 0 ? void 0 : item.desc) !== null && _d !== void 0 ? _d : '',
                    invisible: (_e = item.invisible) !== null && _e !== void 0 ? _e : false,
                    name: (_f = item === null || item === void 0 ? void 0 : item.name) !== null && _f !== void 0 ? _f : '',
                    operationType: (_g = item === null || item === void 0 ? void 0 : item.operationType) !== null && _g !== void 0 ? _g : 'I',
                    readable: (_h = item === null || item === void 0 ? void 0 : item.readable) !== null && _h !== void 0 ? _h : false,
                    value: (_j = item === null || item === void 0 ? void 0 : item.value) !== null && _j !== void 0 ? _j : '',
                    valueRange: (_k = item === null || item === void 0 ? void 0 : item.valueRange) !== null && _k !== void 0 ? _k : valueRange,
                    writable: (_l = item === null || item === void 0 ? void 0 : item.writable) !== null && _l !== void 0 ? _l : false
                };
                array.push(attr);
            }
            return array;
        }
    }, {
        key: 'convertLeDeviceAttributeListFrom',
        value: function convertLeDeviceAttributeListFrom(ret) {
            var _a, _b, _c;
            var array = new Array();
            var resultData = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : array;
            for (var i = 0; i < resultData.length; i++) {
                var item = resultData[i];
                var attr = new LeDeviceAttribute();
                attr = {
                    name: (_b = item === null || item === void 0 ? void 0 : item.name) !== null && _b !== void 0 ? _b : '',
                    value: (_c = item === null || item === void 0 ? void 0 : item.value) !== null && _c !== void 0 ? _c : ''
                };
                array.push(attr);
            }
            return array;
        }
    }, {
        key: 'convertBusinessAttrListFrom',
        value: function convertBusinessAttrListFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var array = new Array();
            var resultData = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : array;
            var cmdPara = new CmdPara();
            for (var i = 0; i < resultData.length; i++) {
                var item = resultData[i];
                var attr = new BusinessAttr();
                attr = {
                    alias: (_b = item === null || item === void 0 ? void 0 : item.alias) !== null && _b !== void 0 ? _b : '',
                    desc: (_c = item === null || item === void 0 ? void 0 : item.desc) !== null && _c !== void 0 ? _c : '',
                    desc1: (_d = item === null || item === void 0 ? void 0 : item.desc1) !== null && _d !== void 0 ? _d : '',
                    desc2: (_e = item === null || item === void 0 ? void 0 : item.desc2) !== null && _e !== void 0 ? _e : '',
                    desc3: (_f = item === null || item === void 0 ? void 0 : item.desc3) !== null && _f !== void 0 ? _f : '',
                    desc4: (_g = item === null || item === void 0 ? void 0 : item.desc4) !== null && _g !== void 0 ? _g : '',
                    name: (_h = item === null || item === void 0 ? void 0 : item.name) !== null && _h !== void 0 ? _h : '',
                    detailDesc: (_j = item === null || item === void 0 ? void 0 : item.detailDesc) !== null && _j !== void 0 ? _j : '',
                    cmdPara: (_k = item === null || item === void 0 ? void 0 : item.cmdPara) !== null && _k !== void 0 ? _k : cmdPara
                };
                array.push(attr);
            }
            return array;
        }
    }, {
        key: 'convertUserInfoFrom',
        value: function convertUserInfoFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
            var userInfo = new UserInfo();
            userInfo.userId = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.uhome_user_id) !== null && _b !== void 0 ? _b : '';
            userInfo.offUserId = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.user_center_userId) !== null && _d !== void 0 ? _d : '';
            userInfo.uhome_access_token = (_f = (_e = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _e === void 0 ? void 0 : _e.uhome_access_token) !== null && _f !== void 0 ? _f : '';
            userInfo.user_center_access_token = (_h = (_g = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _g === void 0 ? void 0 : _g.user_center_access_token) !== null && _h !== void 0 ? _h : '';
            userInfo.phoneNumber = (_l = (_k = (_j = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _j === void 0 ? void 0 : _j.extraInfo) === null || _k === void 0 ? void 0 : _k.mobile) !== null && _l !== void 0 ? _l : '';
            userInfo.realName = (_p = (_o = (_m = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _m === void 0 ? void 0 : _m.extraInfo) === null || _o === void 0 ? void 0 : _o.givenName) !== null && _p !== void 0 ? _p : '';
            userInfo.nickname = (_s = (_r = (_q = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _q === void 0 ? void 0 : _q.extraInfo) === null || _r === void 0 ? void 0 : _r.nickname) !== null && _s !== void 0 ? _s : '';
            userInfo.avatar = (_v = (_u = (_t = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _t === void 0 ? void 0 : _t.extraInfo) === null || _u === void 0 ? void 0 : _u.avatarUrl) !== null && _v !== void 0 ? _v : '';
            userInfo.email = (_y = (_x = (_w = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _w === void 0 ? void 0 : _w.extraInfo) === null || _x === void 0 ? void 0 : _x.email) !== null && _y !== void 0 ? _y : '';
            userInfo.username = (_1 = (_0 = (_z = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _z === void 0 ? void 0 : _z.extraInfo) === null || _0 === void 0 ? void 0 : _0.username) !== null && _1 !== void 0 ? _1 : '';
            return userInfo;
        }
    }, {
        key: 'convertOauthDataFrom',
        value: function convertOauthDataFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var oauthData = new OauthData();
            oauthData.user_center_access_token = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : '';
            oauthData.expires_in = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.expires_in) !== null && _d !== void 0 ? _d : '';
            oauthData.refresh_token = (_f = (_e = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _e === void 0 ? void 0 : _e.refresh_token) !== null && _f !== void 0 ? _f : '';
            oauthData.uhome_access_token = (_h = (_g = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _g === void 0 ? void 0 : _g.uhome_access_token) !== null && _h !== void 0 ? _h : '';
            oauthData.uhome_user_id = (_k = (_j = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _j === void 0 ? void 0 : _j.uhome_user_id) !== null && _k !== void 0 ? _k : '';
            return oauthData;
        }
    }, {
        key: 'convertLocationInfoFrom',
        value: function convertLocationInfoFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
            var info = new LocationInfo();
            info.latitude = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.latitude) !== null && _b !== void 0 ? _b : '';
            info.longitude = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.longitude) !== null && _d !== void 0 ? _d : '';
            info.country = (_f = (_e = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _e === void 0 ? void 0 : _e.country) !== null && _f !== void 0 ? _f : '';
            info.province = (_h = (_g = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _g === void 0 ? void 0 : _g.province) !== null && _h !== void 0 ? _h : '';
            info.city = (_k = (_j = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _j === void 0 ? void 0 : _j.city) !== null && _k !== void 0 ? _k : '';
            info.district = (_m = (_l = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _l === void 0 ? void 0 : _l.district) !== null && _m !== void 0 ? _m : '';
            info.citycode = (_p = (_o = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _o === void 0 ? void 0 : _o.citycode) !== null && _p !== void 0 ? _p : '';
            info.adcode = (_r = (_q = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _q === void 0 ? void 0 : _q.adcode) !== null && _r !== void 0 ? _r : '';
            info.street = (_t = (_s = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _s === void 0 ? void 0 : _s.street) !== null && _t !== void 0 ? _t : '';
            info.number = (_v = (_u = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _u === void 0 ? void 0 : _u.number) !== null && _v !== void 0 ? _v : '';
            info.POIName = (_x = (_w = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _w === void 0 ? void 0 : _w.POIName) !== null && _x !== void 0 ? _x : '';
            info.AOIName = (_z = (_y = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _y === void 0 ? void 0 : _y.AOIName) !== null && _z !== void 0 ? _z : '';
            return info;
        }
    }, {
        key: 'convertInstallStatusFrom',
        value: function convertInstallStatusFrom(ret) {
            var _a;
            var status = new InstallStatus();
            status.status = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : false;
            return status;
        }
    }, {
        key: 'convertLoginStatusFrom',
        value: function convertLoginStatusFrom(ret) {
            var _a;
            var status = new LoginStatus();
            var retData = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : 'NotLogin';
            if (retData === 'DidLogin') {
                status.isLogin = true;
            } else if (retData === 'Logging') {
                status.isLogining = true;
            }
            return status;
        }
    }, {
        key: 'convertAppInfoFrom',
        value: function convertAppInfoFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
            var info = new AppInformation();
            info.appId = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.appId) !== null && _b !== void 0 ? _b : '';
            info.appKey = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.appKey) !== null && _d !== void 0 ? _d : '';
            info.appVersion = (_f = (_e = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _e === void 0 ? void 0 : _e.appVersion) !== null && _f !== void 0 ? _f : '';
            info.clientId = (_h = (_g = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _g === void 0 ? void 0 : _g.clientId) !== null && _h !== void 0 ? _h : '';
            info.haierClientId = (_k = (_j = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _j === void 0 ? void 0 : _j.haierClientId) !== null && _k !== void 0 ? _k : '';
            info.haierClientSecret = (_m = (_l = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _l === void 0 ? void 0 : _l.haierClientSecret) !== null && _m !== void 0 ? _m : '';
            info.haierUserCenterUrl = (_p = (_o = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _o === void 0 ? void 0 : _o.haierUserCenterUrl) !== null && _p !== void 0 ? _p : '';
            info.grayMode = (_r = (_q = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _q === void 0 ? void 0 : _q.grayMode) !== null && _r !== void 0 ? _r : false;
            info.env = (_t = (_s = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _s === void 0 ? void 0 : _s.env) !== null && _t !== void 0 ? _t : '';
            info.isPreViewEnv = (_v = (_u = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _u === void 0 ? void 0 : _u.isPreViewEnv) !== null && _v !== void 0 ? _v : false;
            info.platform = (_x = (_w = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _w === void 0 ? void 0 : _w.platform) !== null && _x !== void 0 ? _x : '';
            info.OSversion = (_z = (_y = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _y === void 0 ? void 0 : _y.OSversion) !== null && _z !== void 0 ? _z : '';
            info.idfa = (_1 = (_0 = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _0 === void 0 ? void 0 : _0.idfa) !== null && _1 !== void 0 ? _1 : '';
            info.testMode = (_3 = (_2 = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _2 === void 0 ? void 0 : _2.testMode) !== null && _3 !== void 0 ? _3 : false;
            return info;
        }
    }, {
        key: 'convertPhoneInfoForm',
        value: function convertPhoneInfoForm(ret) {
            var _a, _b;
            var info = new PhoneInfo();
            info.model = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.model) !== null && _b !== void 0 ? _b : '';
            return info;
        }
    }, {
        key: 'convertNetWorkStatusFrom',
        value: function convertNetWorkStatusFrom(ret) {
            var _a;
            var info = new NetworkStatus();
            info.isOnline = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) !== null && _a !== void 0 ? _a : false;
            return info;
        }
    }, {
        key: 'convertNetWorkInfoFrom',
        value: function convertNetWorkInfoFrom(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var info = new NetworkInfo();
            info.type = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.type;
            info.ip = (_c = (_b = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _b === void 0 ? void 0 : _b.ip) !== null && _c !== void 0 ? _c : '';
            info.cellType = (_e = (_d = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _d === void 0 ? void 0 : _d.cellType) !== null && _e !== void 0 ? _e : '';
            info.mac = (_g = (_f = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _f === void 0 ? void 0 : _f.mac) !== null && _g !== void 0 ? _g : '';
            info.ssid = (_j = (_h = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _h === void 0 ? void 0 : _h.ssid) !== null && _j !== void 0 ? _j : '';
            return info;
        }
    }, {
        key: 'converImagePickerInfoFrom',
        value: function converImagePickerInfoFrom(ret) {
            // console.log('converImagePickerInfoFrom', ret);
            var imagePickerInfo = new ImagePickerInfo();
            imagePickerInfo.eventType = 'nextStep';
            var imageInfo = new ImageInfo();
            imageInfo.path = ret.retData;
            imageInfo.thumbPath = '';
            imagePickerInfo.list.push(imageInfo);
            return imagePickerInfo;
        }
    }, {
        key: 'convertOpenCameraInfoFrom',
        value: function convertOpenCameraInfoFrom(ret) {
            var _a, _b, _c, _d, _e, _f;
            var openCameraInfo = new OpenCameraInfo();
            openCameraInfo.eventType = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.eventType;
            openCameraInfo.base64Data = (_b = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _b === void 0 ? void 0 : _b.base64Data;
            openCameraInfo.data = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.data;
            openCameraInfo.exif = (_f = (_e = (_d = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.exif) !== null && _f !== void 0 ? _f : '';
            return openCameraInfo;
        }
    }, {
        key: 'converTransPathInfoFrom',
        value: function converTransPathInfoFrom(ret) {
            var _a;
            var info = new TransPathInfo();
            info.path = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.path;
            return info;
        }
    }, {
        key: 'nebulaConverAudioAttrInfoFrom',
        value: function nebulaConverAudioAttrInfoFrom(ret) {
            var _a, _b, _c, _d;
            var info = new AttrData();
            info.duration = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.duration) !== null && _b !== void 0 ? _b : 0;
            info.length = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
            return info;
        }
    }, {
        key: 'converAudioAttrInfoFrom',
        value: function converAudioAttrInfoFrom(ret) {
            var _a, _b;
            var info = new AttrData();
            info.duration = (_a = ret === null || ret === void 0 ? void 0 : ret.duration) !== null && _a !== void 0 ? _a : 0;
            info.length = (_b = ret === null || ret === void 0 ? void 0 : ret.length) !== null && _b !== void 0 ? _b : 0;
            return info;
        }
    }, {
        key: 'createDeviceAlarmFrom',
        value: function createDeviceAlarmFrom(alarm) {
            var _a, _b, _c, _d, _e;
            var caution = new Alarm();
            caution.name = (_a = alarm === null || alarm === void 0 ? void 0 : alarm.name) !== null && _a !== void 0 ? _a : '';
            caution.value = (_b = alarm === null || alarm === void 0 ? void 0 : alarm.value) !== null && _b !== void 0 ? _b : '';
            caution.time = (_c = alarm === null || alarm === void 0 ? void 0 : alarm.time) !== null && _c !== void 0 ? _c : '';
            caution.message = (_d = alarm === null || alarm === void 0 ? void 0 : alarm.message) !== null && _d !== void 0 ? _d : '';
            caution.clear = (_e = alarm === null || alarm === void 0 ? void 0 : alarm.clear) !== null && _e !== void 0 ? _e : false;
            return caution;
        }
    }, {
        key: 'convertFotaStatusForm',
        value: function convertFotaStatusForm(ret) {
            var _a, _b, _c, _d;
            var status = new FOTAStatus();
            status.upgradeErrInfo = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.upgradeErrInfo) !== null && _b !== void 0 ? _b : '';
            status.upgradeStatus = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.upgradeStatus) !== null && _d !== void 0 ? _d : 106;
            return status;
        }
    }, {
        key: 'convertFotaInfoForm',
        value: function convertFotaInfoForm(ret) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var fotaInfo = new FOTAInfo();
            fotaInfo.currentVersion = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.currentVersion) !== null && _b !== void 0 ? _b : '';
            fotaInfo.isNeedFOTA = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.isNeedFOTA) !== null && _d !== void 0 ? _d : false;
            fotaInfo.model = (_f = (_e = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _e === void 0 ? void 0 : _e.model) !== null && _f !== void 0 ? _f : '';
            fotaInfo.newestVersion = (_h = (_g = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _g === void 0 ? void 0 : _g.newestVersion) !== null && _h !== void 0 ? _h : '';
            fotaInfo.newestVersionDescription = (_k = (_j = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _j === void 0 ? void 0 : _j.newestVersionDescription) !== null && _k !== void 0 ? _k : '';
            fotaInfo.timeoutInterval = (_m = (_l = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _l === void 0 ? void 0 : _l.timeoutInterval) !== null && _m !== void 0 ? _m : 0;
            return fotaInfo;
        }
    }, {
        key: 'convertUpDeviceBaseInfoList',
        value: function convertUpDeviceBaseInfoList(ret) {
            var _this2 = this;

            var infoList = ret.retData ? ret.retData : [];
            var list = [];
            infoList.map(function (info) {
                var infoObj = _this2.createUpdeviceBaseInfoFrom(info.baseInfo);
                list.push(infoObj);
            });
            return list;
        }
    }, {
        key: 'createUpdeviceBaseInfoFrom',
        value: function createUpdeviceBaseInfoFrom(devInfo) {
            var devBaseInfo = new UpDeviceBaseInfo();
            devBaseInfo.deviceId = devInfo === null || devInfo === void 0 ? void 0 : devInfo.deviceId;
            devBaseInfo.model = devInfo === null || devInfo === void 0 ? void 0 : devInfo.model;
            devBaseInfo.parentId = devInfo === null || devInfo === void 0 ? void 0 : devInfo.parentId;
            devBaseInfo.prodNo = devInfo === null || devInfo === void 0 ? void 0 : devInfo.prodNo;
            devBaseInfo.protocol = devInfo === null || devInfo === void 0 ? void 0 : devInfo.protocol;
            devBaseInfo.subDevNo = devInfo === null || devInfo === void 0 ? void 0 : devInfo.subDevNo;
            devBaseInfo.typeCode = devInfo === null || devInfo === void 0 ? void 0 : devInfo.typeCode;
            devBaseInfo.typeName = devInfo === null || devInfo === void 0 ? void 0 : devInfo.subDevNo;
            devBaseInfo.typeId = devInfo === null || devInfo === void 0 ? void 0 : devInfo.typeId;
            return devBaseInfo;
        }
    }, {
        key: 'createBindProgressFrom',
        value: function createBindProgressFrom(bindProgressType) {
            var bindProgress = BindProgress.BIND_DEVICE_FAILURE;
            if (bindProgressType === 'CONNECT_DEVICE') {
                bindProgress = BindProgress.CONNECT_DEVICE;
            } else if (bindProgressType === 'SEND_CONFIG_INFO') {
                bindProgress = BindProgress.SEND_CONFIG_INFO;
            } else if (bindProgressType === 'VERIFICATION') {
                bindProgress = BindProgress.VERIFICATION;
            } else if (bindProgressType === 'BIND_DEVICE') {
                bindProgress = BindProgress.BIND_DEVICE;
            } else if (bindProgressType === 'START_NETWORKING_MODE') {
                bindProgress = BindProgress.START_NETWORKING_MODE;
            } else if (bindProgressType === 'START_NETWORKING') {
                bindProgress = BindProgress.START_NETWORKING;
            } else if (bindProgressType === 'START_BIND_SLAVE_DEVICE') {
                bindProgress = BindProgress.START_BIND_SLAVE_DEVICE;
            } else if (bindProgressType === 'BIND_DEVICE_SUCCESS') {
                bindProgress = BindProgress.BIND_DEVICE_SUCCESS;
            } else if (bindProgressType === 'BIND_PROGRESS_CONNECT_FAILURE') {
                bindProgress = BindProgress.BIND_PROGRESS_CONNECT_FAILURE;
            } else if (bindProgressType === 'BIND_DEVICE_FAILURE') {
                bindProgress = BindProgress.BIND_DEVICE_FAILURE;
            }
            return bindProgress;
        }
    }, {
        key: 'createDeviceModelFrom',
        value: function createDeviceModelFrom(deviceInfo) {
            var deviceModel = new DeviceModel();
            var baseInfo = deviceInfo.baseInfo ? deviceInfo.baseInfo : deviceModel.baseInfo;
            var extras = deviceInfo.extras;
            var basic = extras && extras.basic ? extras.basic : deviceModel.extras.basic;
            var permission = extras && extras.permission ? extras.permission : deviceModel.extras.permission;
            var product = extras && extras.product ? extras.product : deviceModel.extras.product;
            var relation = extras && extras.relation ? extras.relation : deviceModel.extras.relation;
            deviceModel.connection = deviceInfo.connection && deviceInfo.connection === 'READY' ? 'ONLINE' : 'OFFLINE';
            deviceModel.deviceOnlineStatus = deviceInfo.deviceOnlineStatus;
            deviceModel.controlState = deviceInfo.controlState;
            deviceModel.faultInformationStateCode = deviceInfo.faultInformationStateCode;
            deviceModel.subDevList = deviceInfo.subDevList ? deviceInfo.subDevList : deviceModel.subDevList;
            deviceModel.attributes = deviceInfo.attributes ? deviceInfo.attributes : {};
            deviceModel.cautions = deviceInfo.cautions ? deviceInfo.cautions : {};
            deviceModel.configState = deviceInfo.configState;
            deviceModel.sleepState = deviceInfo.sleepState;
            deviceModel.deviceNetworkLevel = deviceInfo.deviceNetworkLevel;
            deviceModel.onlineStateV2 = deviceInfo.onlineStateV2;
            deviceModel.bleState = deviceInfo.bleState;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(deviceModel.baseInfo)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    if (baseInfo[key] !== undefined && baseInfo[key] !== null) {
                        // @ts-ignore
                        deviceModel.baseInfo[key] = baseInfo[key];
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(deviceModel.extras.basic)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _key = _step2.value;

                    // tslint:disable-next-line:no-string-literal
                    if (_key === 'subDeviceIds' && basic['subDevIds'] !== undefined && basic['subDevIds'] !== null) {
                        // tslint:disable-next-line:no-string-literal
                        deviceModel.extras.basic[_key] = basic['subDevIds'];
                    }
                    if (basic[_key] !== undefined && basic[_key] !== null) {
                        // @ts-ignore
                        deviceModel.extras.basic[_key] = basic[_key];
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                        _iterator2['return']();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = Object.keys(deviceModel.extras.permission)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _key2 = _step3.value;

                    if (permission[_key2] !== undefined && permission[_key2] !== null) {
                        // @ts-ignore
                        deviceModel.extras.permission[_key2] = permission[_key2];
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                        _iterator3['return']();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = Object.keys(deviceModel.extras.product)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _key3 = _step4.value;

                    if (product[_key3] !== undefined && product[_key3] !== null) {
                        // @ts-ignore
                        deviceModel.extras.product[_key3] = product[_key3];
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4['return']) {
                        _iterator4['return']();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = Object.keys(deviceModel.extras.relation)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var _key4 = _step5.value;

                    if (relation[_key4] !== undefined && relation[_key4] !== null) {
                        // @ts-ignore
                        deviceModel.extras.relation[_key4] = relation[_key4];
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5['return']) {
                        _iterator5['return']();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return deviceModel;
        }
    }, {
        key: 'createDeviceInfoModelFrom',
        value: function createDeviceInfoModelFrom(deviceInfo) {
            var deviceModel = new DeviceModelMixLogicAttrs();
            var baseInfo = deviceInfo.baseInfo ? deviceInfo.baseInfo : deviceModel.baseInfo;
            var extras = deviceInfo.extras;
            var basic = extras && extras.basic ? extras.basic : deviceModel.extras.basic;
            var permission = extras && extras.permission ? extras.permission : deviceModel.extras.permission;
            var product = extras && extras.product ? extras.product : deviceModel.extras.product;
            var relation = extras && extras.relation ? extras.relation : deviceModel.extras.relation;
            deviceModel.connection = deviceInfo.connection && deviceInfo.connection === 'READY' ? 'ONLINE' : 'OFFLINE';
            deviceModel.deviceOnlineStatus = deviceInfo.deviceOnlineStatus;
            deviceModel.controlState = deviceInfo.controlState;
            deviceModel.faultInformationStateCode = deviceInfo.faultInformationStateCode;
            deviceModel.subDevList = deviceInfo.subDevList ? deviceInfo.subDevList : deviceModel.subDevList;
            deviceModel.attributes = deviceInfo.attributes ? deviceInfo.attributes : {};
            deviceModel.cautions = deviceInfo.cautions ? deviceInfo.cautions : {};
            deviceModel.engineAttributes = deviceInfo.engineAttributes ? deviceInfo.engineAttributes : {};
            deviceModel.engineCautions = deviceInfo.engineCautions ? deviceInfo.engineCautions : {};
            deviceModel.configState = deviceInfo.configState;
            deviceModel.onlineStateV2 = deviceInfo.onlineStateV2;
            deviceModel.bleState = deviceInfo.bleState;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = Object.keys(deviceModel.baseInfo)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var key = _step6.value;

                    if (baseInfo[key] !== undefined && baseInfo[key] !== null) {
                        // @ts-ignore
                        deviceModel.baseInfo[key] = baseInfo[key];
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6['return']) {
                        _iterator6['return']();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = Object.keys(deviceModel.extras.basic)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _key5 = _step7.value;

                    // tslint:disable-next-line:no-string-literal
                    if (_key5 === 'subDeviceIds' && basic['subDevIds'] !== undefined && basic['subDevIds'] !== null) {
                        // tslint:disable-next-line:no-string-literal
                        deviceModel.extras.basic[_key5] = basic['subDevIds'];
                    }
                    if (basic[_key5] !== undefined && basic[_key5] !== null) {
                        // @ts-ignore
                        deviceModel.extras.basic[_key5] = basic[_key5];
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7['return']) {
                        _iterator7['return']();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
                for (var _iterator8 = Object.keys(deviceModel.extras.permission)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var _key6 = _step8.value;

                    if (permission[_key6] !== undefined && permission[_key6] !== null) {
                        // @ts-ignore
                        deviceModel.extras.permission[_key6] = permission[_key6];
                    }
                }
            } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion8 && _iterator8['return']) {
                        _iterator8['return']();
                    }
                } finally {
                    if (_didIteratorError8) {
                        throw _iteratorError8;
                    }
                }
            }

            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = Object.keys(deviceModel.extras.product)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var _key7 = _step9.value;

                    if (product[_key7] !== undefined && product[_key7] !== null) {
                        // @ts-ignore
                        deviceModel.extras.product[_key7] = product[_key7];
                    }
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9['return']) {
                        _iterator9['return']();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = Object.keys(deviceModel.extras.relation)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var _key8 = _step10.value;

                    if (relation[_key8] !== undefined && relation[_key8] !== null) {
                        // @ts-ignore
                        deviceModel.extras.relation[_key8] = relation[_key8];
                    }
                }
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10['return']) {
                        _iterator10['return']();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }

            return deviceModel;
        }
    }, {
        key: 'createSimplifyModelFrom',
        value: function createSimplifyModelFrom(deviceInfo) {
            var deviceModel = new SimplifyDataModel();
            deviceModel.deviceId = deviceInfo.deviceId;
            deviceModel.connection = deviceInfo.connection && deviceInfo.connection === 'READY' ? 'ONLINE' : 'OFFLINE';
            deviceModel.attributes = deviceInfo.attributes ? deviceInfo.attributes : {};
            deviceModel.cautions = deviceInfo.cautions ? deviceInfo.cautions : {};
            deviceModel.engineAttributes = deviceInfo.engineAttributes ? deviceInfo.engineAttributes : {};
            deviceModel.engineCautions = deviceInfo.engineCautions ? deviceInfo.engineCautions : {};
            deviceModel.configState = deviceInfo.configState;
            return deviceModel;
        }
    }, {
        key: 'convertRoomsFrom',
        value: function convertRoomsFrom(ret) {
            var roomInfos = [];
            ret.retData.forEach(function (room) {
                if (room) {
                    var roomInfo = new RoomInfo();
                    roomInfo.roomId = room.id || '';
                    roomInfo.roomName = room.name || '';
                    roomInfos.push(roomInfo);
                }
            });
            return roomInfos;
        }
    }, {
        key: 'convertFamilyMapFrom',
        value: function convertFamilyMapFrom(ret) {
            var _a, _b, _c, _d;
            var list = [];
            var families = ret.retData && ret.retData.families ? ret.retData.families : {};
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = Object.keys(families)[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var key = _step11.value;

                    var family = families[key];
                    if (family) {
                        (function () {
                            var familyInfo = new FamilyInfo();
                            var info = family.info ? family.info : {};
                            var members = family.members ? family.members : [];
                            var owner = family.owner ? family.owner : {};
                            var sharedDevices = family.devices ? family.devices : {};
                            var firstMember = family.firstMember ? family.firstMember : {};
                            var floors = family.floorInfos ? family.floorInfos : [];
                            familyInfo.createTime = family.createTime ? family.createTime : '';
                            familyInfo.familyId = family.familyId ? family.familyId : '';
                            familyInfo.locationChangeFlag = family.locationChangeFlag ? family.locationChangeFlag : false;
                            // owner赋值
                            var fd = new FamilyOwnerDetail();
                            fd.avatarUrl = owner.avatarUrl || '';
                            fd.mobile = owner.mobile || '';
                            fd.userId = owner.userId || '';
                            familyInfo.owner = fd;
                            // fristMember赋值
                            var fm = new MemberInfo();
                            fm.joinTime = firstMember.joinTime || '';
                            fm.memberName = firstMember.memberName || '';
                            fm.shareDeviceCount = firstMember.shareDeviceCount;
                            var memberInfo = new MemberDetail();
                            memberInfo.avatarUrl = ((_a = firstMember.memberInfo) === null || _a === void 0 ? void 0 : _a.avatarUrl) || '';
                            memberInfo.mobile = ((_b = firstMember.memberInfo) === null || _b === void 0 ? void 0 : _b.mobile) || '';
                            memberInfo.name = ((_c = firstMember.memberInfo) === null || _c === void 0 ? void 0 : _c.name) || '';
                            memberInfo.userId = ((_d = firstMember.memberInfo) === null || _d === void 0 ? void 0 : _d.userId) || '';
                            fm.memberInfo = memberInfo;
                            familyInfo.firstMember = fm;
                            // info赋值
                            var familyDetailInfo = new FamilyDetail();
                            familyDetailInfo.familyName = info.familyName || '';
                            familyDetailInfo.familyPosition = info.familyPosition || '';
                            var familyLocationDetail = new FamilyLocationDetail();
                            familyLocationDetail.cityCode = info.familyLocation.cityCode || '';
                            familyLocationDetail.latitude = Number(info.familyLocation.latitude);
                            familyLocationDetail.longitude = Number(info.familyLocation.longitude);
                            familyDetailInfo.familyLocation = familyLocationDetail;
                            familyInfo.info = familyDetailInfo;
                            familyInfo.sharedDevices = [];
                            var _iteratorNormalCompletion12 = true;
                            var _didIteratorError12 = false;
                            var _iteratorError12 = undefined;

                            try {
                                for (var _iterator12 = Object.keys(sharedDevices)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                                    var d = _step12.value;

                                    if (sharedDevices[d]) {
                                        var sharedDevice = sharedDevices[d];
                                        var dInfo = new DeviceInfo();
                                        dInfo.apptypeName = sharedDevice.apptypeName || '';
                                        dInfo.brand = sharedDevice.brand || '';
                                        dInfo.deviceId = sharedDevice.deviceId || '';
                                        dInfo.deviceName = sharedDevice.deviceName || '';
                                        dInfo.deviceType = sharedDevice.deviceType || '';
                                        dInfo.deviceRole = sharedDevice.deviceRole || '';
                                        dInfo.deviceRoleType = sharedDevice.deviceRoleType || '';
                                        dInfo.imageAddr1 = sharedDevice.imageAddr1 || '';
                                        dInfo.imageAddr2 = sharedDevice.imageAddr2 || '';
                                        dInfo.isOnline = Boolean(sharedDevice.isOnline);
                                        dInfo.model = sharedDevice.model || '';
                                        dInfo.wifiType = sharedDevice.wifiType || '';
                                        dInfo.prodNo = sharedDevice.prodNo || '';
                                        dInfo.bindType = sharedDevice.bindType || '';
                                        dInfo.comunicationMode = sharedDevice.comunicationMode || '';
                                        dInfo.ownerId = sharedDevice.ownerInfo.userId || '';
                                        dInfo.devFloorId = sharedDevice.devFloorId || '';
                                        dInfo.devFloorName = sharedDevice.devFloorName || '';
                                        dInfo.devFloorOrderId = sharedDevice.devFloorOrderId || '';
                                        dInfo.deviceNetType = sharedDevice.deviceNetType || '';
                                        var ownerDetail = new OwnerDetail();
                                        ownerDetail.userId = sharedDevice.ownerInfo.userId || '';
                                        ownerDetail.mobile = sharedDevice.ownerInfo.mobile || '';
                                        dInfo.ownerInfo = ownerDetail;
                                        var permissionDetail = new PermissionDetail();
                                        permissionDetail.authType = sharedDevice.permission.authType || '';
                                        var authDetail = new AuthDetail();
                                        authDetail.control = sharedDevice.permission.auth.control;
                                        authDetail.set = sharedDevice.permission.auth.set;
                                        authDetail.view = sharedDevice.permission.auth.view;
                                        permissionDetail.auth = authDetail;
                                        dInfo.permission = permissionDetail;
                                        var roomInfo = new RoomInfo();
                                        roomInfo.familyId = familyInfo.familyId || '';
                                        roomInfo.roomId = sharedDevice.room.roomId || '';
                                        roomInfo.roomName = sharedDevice.room.roomName || '';
                                        dInfo.room = roomInfo;
                                        familyInfo.sharedDevices.push(dInfo);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError12 = true;
                                _iteratorError12 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion12 && _iterator12['return']) {
                                        _iterator12['return']();
                                    }
                                } finally {
                                    if (_didIteratorError12) {
                                        throw _iteratorError12;
                                    }
                                }
                            }

                            familyInfo.members = [];
                            members.forEach(function (member) {
                                var _a, _b, _c, _d;
                                if (member) {
                                    var mInfo = new MemberInfo();
                                    mInfo.joinTime = member.joinTime || '';
                                    mInfo.memberName = member.memberName || '';
                                    mInfo.shareDeviceCount = member.shareDeviceCount;
                                    var memberDetail = new MemberDetail();
                                    memberDetail.avatarUrl = ((_a = member.memberInfo) === null || _a === void 0 ? void 0 : _a.avatarUrl) || '';
                                    memberDetail.mobile = ((_b = member.memberInfo) === null || _b === void 0 ? void 0 : _b.mobile) || '';
                                    memberDetail.name = ((_c = member.memberInfo) === null || _c === void 0 ? void 0 : _c.name) || '';
                                    memberDetail.userId = ((_d = member.memberInfo) === null || _d === void 0 ? void 0 : _d.userId) || '';
                                    mInfo.memberInfo = memberDetail;
                                    familyInfo.members.push(mInfo);
                                }
                            });
                            familyInfo.floorInfos = [];
                            floors.forEach(function (floor) {
                                if (floor) {
                                    var floorInfo = new FloorInfo();
                                    floorInfo.floorId = floor.floorId || '';
                                    floorInfo.floorOrderId = floor.floorOrderId || '';
                                    floorInfo.floorName = floor.floorName || '';
                                    floorInfo.floorClass = floor.floorClass || '';
                                    floorInfo.floorLabel = floor.floorLabel || '';
                                    floorInfo.floorLogo = floor.floorLogo || '';
                                    floorInfo.floorPicture = floor.floorPicture || '';
                                    floorInfo.floorCreateTime = floor.floorCreateTime || '';
                                    floorInfo.rooms = [];
                                    var rooms = floor.rooms ? floor.rooms : [];
                                    rooms.forEach(function (room) {
                                        if (room) {
                                            var roomInfo = new RoomInfo();
                                            roomInfo.familyId = familyInfo.familyId || '';
                                            roomInfo.roomId = room.roomId || '';
                                            roomInfo.roomName = room.roomName || '';
                                            floorInfo.rooms.push(roomInfo);
                                        }
                                    });
                                    familyInfo.floorInfos.push(floorInfo);
                                }
                            });
                            list.push(familyInfo);
                        })();
                    }
                }
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11['return']) {
                        _iterator11['return']();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }

            return list;
        }
    }, {
        key: 'convertFamilyId',
        value: function convertFamilyId(ret) {
            var _a;
            var familyInfo = new FamilyInfo();
            familyInfo.familyId = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.familyId;
            return familyInfo;
        }
    }, {
        key: 'convertCurrentFamilyFrom',
        value: function convertCurrentFamilyFrom(ret) {
            var _a, _b, _c, _d;
            var familyInfo = new FamilyInfo();
            var family = ret.retData && ret.retData.currentFamily ? ret.retData.currentFamily : {};
            var info = family.info ? family.info : {};
            var members = family.members ? family.members : [];
            var owner = family.owner ? family.owner : {};
            var floors = family.floorInfos ? family.floorInfos : [];
            var sharedDevices = family.devices ? family.devices : {};
            var firstMember = family.firstMember ? family.firstMember : {};
            familyInfo.createTime = family.createTime ? family.createTime : '';
            familyInfo.familyId = family.familyId ? family.familyId : '';
            familyInfo.locationChangeFlag = family.locationChangeFlag ? family.locationChangeFlag : false;
            // owner赋值
            var fd = new FamilyOwnerDetail();
            fd.avatarUrl = owner.avatarUrl || '';
            fd.mobile = owner.mobile || '';
            fd.userId = owner.userId || '';
            familyInfo.owner = fd;
            // fristMember赋值
            var fm = new MemberInfo();
            fm.joinTime = firstMember.joinTime || '';
            fm.memberName = firstMember.memberName || '';
            fm.shareDeviceCount = firstMember.shareDeviceCount;
            var memberInfo = new MemberDetail();
            memberInfo.avatarUrl = ((_a = firstMember.memberInfo) === null || _a === void 0 ? void 0 : _a.avatarUrl) || '';
            memberInfo.mobile = ((_b = firstMember.memberInfo) === null || _b === void 0 ? void 0 : _b.mobile) || '';
            memberInfo.name = ((_c = firstMember.memberInfo) === null || _c === void 0 ? void 0 : _c.name) || '';
            memberInfo.userId = ((_d = firstMember.memberInfo) === null || _d === void 0 ? void 0 : _d.userId) || '';
            fm.memberInfo = memberInfo;
            familyInfo.firstMember = fm;
            // info赋值
            var familyDetailInfo = new FamilyDetail();
            familyDetailInfo.familyName = info.familyName || '';
            familyDetailInfo.familyPosition = info.familyPosition || '';
            var familyLocationDetail = new FamilyLocationDetail();
            var familyLocation = info.familyLocation ? info.familyLocation : {};
            familyLocationDetail.cityCode = familyLocation.cityCode || '';
            familyLocationDetail.latitude = Number(familyLocation.latitude);
            familyLocationDetail.longitude = Number(familyLocation.longitude);
            familyDetailInfo.familyLocation = familyLocationDetail;
            familyInfo.info = familyDetailInfo;
            familyInfo.sharedDevices = [];
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
                for (var _iterator13 = Object.keys(sharedDevices)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                    var d = _step13.value;

                    if (sharedDevices[d]) {
                        var sharedDevice = sharedDevices[d];
                        var dInfo = new DeviceInfo();
                        dInfo.apptypeName = sharedDevice.apptypeName || '';
                        dInfo.brand = sharedDevice.brand || '';
                        dInfo.deviceId = sharedDevice.deviceId || '';
                        dInfo.deviceName = sharedDevice.deviceName || '';
                        dInfo.deviceType = sharedDevice.deviceType || '';
                        dInfo.deviceRole = sharedDevice.deviceRole || '';
                        dInfo.deviceRoleType = sharedDevice.deviceRoleType || '';
                        dInfo.imageAddr1 = sharedDevice.imageAddr1 || '';
                        dInfo.imageAddr2 = sharedDevice.imageAddr2 || '';
                        dInfo.isOnline = Boolean(sharedDevice.isOnline);
                        dInfo.model = sharedDevice.model || '';
                        dInfo.wifiType = sharedDevice.wifiType || '';
                        dInfo.prodNo = sharedDevice.prodNo || '';
                        dInfo.bindType = sharedDevice.bindType || '';
                        dInfo.bindTime = sharedDevice.bindTime || '';
                        dInfo.comunicationMode = sharedDevice.comunicationMode || '';
                        dInfo.ownerId = sharedDevice.ownerInfo.userId || '';
                        dInfo.devFloorId = sharedDevice.devFloorId || '';
                        dInfo.devFloorName = sharedDevice.devFloorName || '';
                        dInfo.devFloorOrderId = sharedDevice.devFloorOrderId || '';
                        dInfo.deviceNetType = sharedDevice.deviceNetType || '';
                        var ownerDetail = new OwnerDetail();
                        ownerDetail.userId = sharedDevice.ownerInfo.userId || '';
                        ownerDetail.mobile = sharedDevice.ownerInfo.mobile || '';
                        dInfo.ownerInfo = ownerDetail;
                        var permissionDetail = new PermissionDetail();
                        permissionDetail.authType = sharedDevice.permission.authType || '';
                        var authDetail = new AuthDetail();
                        authDetail.control = sharedDevice.permission.auth.control;
                        authDetail.set = sharedDevice.permission.auth.set;
                        authDetail.view = sharedDevice.permission.auth.view;
                        permissionDetail.auth = authDetail;
                        dInfo.permission = permissionDetail;
                        var roomInfo = new RoomInfo();
                        roomInfo.familyId = familyInfo.familyId || '';
                        roomInfo.roomId = sharedDevice.room.roomId || '';
                        roomInfo.roomName = sharedDevice.room.roomName || '';
                        dInfo.room = roomInfo;
                        familyInfo.sharedDevices.push(dInfo);
                    }
                }
            } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion13 && _iterator13['return']) {
                        _iterator13['return']();
                    }
                } finally {
                    if (_didIteratorError13) {
                        throw _iteratorError13;
                    }
                }
            }

            familyInfo.members = [];
            members.forEach(function (member) {
                var _a, _b, _c, _d;
                if (member) {
                    var mInfo = new MemberInfo();
                    mInfo.joinTime = member.joinTime || '';
                    mInfo.memberName = member.memberName || '';
                    mInfo.shareDeviceCount = member.shareDeviceCount;
                    var memberDetail = new MemberDetail();
                    memberDetail.avatarUrl = ((_a = member.memberInfo) === null || _a === void 0 ? void 0 : _a.avatarUrl) || '';
                    memberDetail.mobile = ((_b = member.memberInfo) === null || _b === void 0 ? void 0 : _b.mobile) || '';
                    memberDetail.name = ((_c = member.memberInfo) === null || _c === void 0 ? void 0 : _c.name) || '';
                    memberDetail.userId = ((_d = member.memberInfo) === null || _d === void 0 ? void 0 : _d.userId) || '';
                    mInfo.memberInfo = memberDetail;
                    familyInfo.members.push(mInfo);
                }
            });
            familyInfo.floorInfos = [];
            floors.forEach(function (floor) {
                if (floor) {
                    var floorInfo = new FloorInfo();
                    floorInfo.floorId = floor.floorId || '';
                    floorInfo.floorOrderId = floor.floorOrderId || '';
                    floorInfo.floorName = floor.floorName || '';
                    floorInfo.floorClass = floor.floorClass || '';
                    floorInfo.floorLabel = floor.floorLabel || '';
                    floorInfo.floorLogo = floor.floorLogo || '';
                    floorInfo.floorPicture = floor.floorPicture || '';
                    floorInfo.floorCreateTime = floor.floorCreateTime || '';
                    floorInfo.rooms = [];
                    var rooms = floor.rooms ? floor.rooms : [];
                    rooms.forEach(function (room) {
                        if (room) {
                            var roomInfo = new RoomInfo();
                            roomInfo.familyId = familyInfo.familyId || '';
                            roomInfo.roomId = room.roomId || '';
                            roomInfo.roomName = room.roomName || '';
                            floorInfo.rooms.push(roomInfo);
                        }
                    });
                    familyInfo.floorInfos.push(floorInfo);
                }
            });
            return familyInfo;
        }
    }, {
        key: 'convertPlayBackItemFrom',
        value: function convertPlayBackItemFrom(ret) {
            var items = [];
            ret.retData.forEach(function (item) {
                if (item) {
                    var itemInfo = new PlaybackItem();
                    itemInfo.startTime = item.startTime || 0;
                    itemInfo.endTime = item.endTime || 0;
                    itemInfo.duration = item.duration || 0;
                    items.push(itemInfo);
                }
            });
            return items;
        }
    }]);

    return ContainerPlugin;
}();

export default ContainerPlugin;